import React from "react";

const InfoIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M18.3333322,28.3333316 L21.6666654,28.3333316 L21.6666654,18.3333322 L18.3333322,18.3333322 L18.3333322,28.3333316 Z M19.9999988,3.33333313 C10.7999994,3.33333313 3.33333313,10.7999994 3.33333313,19.9999988 C3.33333313,29.1999989 10.7999994,36.6666645 19.9999988,36.6666645 C29.1999989,36.6666645 36.6666645,29.1999989 36.6666645,19.9999988 C36.6666645,10.7999986 29.1999989,3.33333313 19.9999988,3.33333313 Z M18.3333322,14.9999991 L21.6666654,14.9999991 L21.6666654,11.666666 L18.3333322,11.666666 L18.3333322,14.9999991 Z"
        id="path-1"
      />
    </defs>
    <g id="Alert/Mixin/Icon/Info" fill="none" fillRule="evenodd">
      <g id="Icon/Info">
        <mask id="mask-2" fill="#fff">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Fill-2" fill="#000" xlinkHref="#path-1" />
        <g id="Colors/Action-Dark" mask="url(#mask-2)" fill="#005095">
          <rect id="foo" width="40" height="40" />
        </g>
      </g>
    </g>
  </svg>
);

export default InfoIcon;
